// import './wdyr'
import './debug'
import '~/core/api'
import '~/core/i18n'
import 'core-js/stable/array/to-spliced'
import type { Root } from 'react-dom/client'

import history from 'history/browser'
import { FiberProvider } from 'its-fine'
import { flushSync } from 'react-dom'
import { createRoot } from 'react-dom/client'
import { App, model as app, Bootstrap, UnknownProvider, versions } from '~/app'
import { config, env } from '~/shared/config'

const container: HTMLElement = document.getElementById('root') as HTMLElement
const root: Root = createRoot(container)

if (window.ERA_CONFIG != null && typeof window.ERA_CONFIG === 'object') {
  // render bootstrap loader before router resolves any route
  root.render(<Bootstrap />)

  // Render and re-render application on each location change
  app.onLocationChange(({ location, route }) => {
    flushSync(() => {
      root.render(
        <FiberProvider>
          <App location={location} route={route} />
        </FiberProvider>
      )
    })
  })

  // init application
  //  -> subscribe to history events
  //  -> add global onclick handler for navigation
  app.init({
    history,
    container,
  })

  //
} else if (window.ERA_CONFIG === 503) {
  // render maintenance page
  root.render(<UnknownProvider text='maintenance' />)
} else {
  // render error page if Era returns no configuration
  root.render(<UnknownProvider text='unknown provider' />)
}

// export versions, environment variables and firebase remote config
// for debug and information purposes
window.VERSIONS = versions
window.ENV = env
window.REMOTE = config
